import React, { useState, useEffect, useRef } from "react";

const ImageWithFallback = ({ src, alt, fallbackSrc, className, style, ...props }) => {
  const effectiveSrc = src || fallbackSrc;
  const [imgSrc, setImgSrc] = useState(effectiveSrc);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const prevSrcRef = useRef(effectiveSrc);

  useEffect(() => {
    const newSrc = src || fallbackSrc;
    if (newSrc === prevSrcRef.current) return;
    prevSrcRef.current = newSrc;
    setImgSrc(newSrc);
    setLoaded(false);
    setError(false);
  }, [src, fallbackSrc]);

  return (
    <div style={{ position: "relative", display: "inline-flex", justifyContent: "center", alignItems: "center", ...style }} className={className}>
      {/* Loading Skeleton / Spinner */}
      {!loaded && !error && (
        <div 
          className="spinner-border text-primary" 
          role="status"
          style={{ 
            position: "absolute",
            width: "1.5rem",
            height: "1.5rem",
            zIndex: 1
          }}
        >
          <span className="visually-hidden">Уншиж байна...</span>
        </div>
      )}
      
      <img
        src={imgSrc}
        alt={alt}
        className={className}
        style={{ 
            ...style, 
            opacity: loaded ? 1 : 0, 
            transition: "opacity 0.3s",
            width: "100%", 
            height: "100%", 
            objectFit: "cover" 
        }}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setError(true);
          setLoaded(true);
          if (fallbackSrc && imgSrc !== fallbackSrc) {
            setImgSrc(fallbackSrc);
          }
        }}
        {...props}
      />
    </div>
  );
};

export default ImageWithFallback;
